module.exports = __webpack_public_path__ + "c0e0f7fece65521cda78e273703db311.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-72.png
// module id = 142
// module chunks = 0